import type { ReactNode } from 'react';
import { cx } from '@/lib/cx';

export type BadgeTone = 'neutral' | 'info' | 'success' | 'warning' | 'danger' | 'accent' | 'navy';

export interface StatusBadgeProps {
  tone?: BadgeTone;
  /** 先頭に丸印（ステータス表示向け） */
  dot?: boolean;
  /** 塗りつぶし（強調） */
  solid?: boolean;
  children: ReactNode;
  title?: string;
}

/**
 * 状態バッジ。業務ステータスの対応例:
 *  未送信=warning / 送信済=success / 承認待ち=info / 差戻し=danger / 下書き=neutral / 基金=navy
 */
export function StatusBadge({ tone = 'neutral', dot, solid, children, title }: StatusBadgeProps) {
  return (
    <span className={cx('bs-badge', `bs-badge--${tone}`, solid && 'is-solid')} title={title}>
      {dot && <span className="bs-badge__dot" aria-hidden />}
      {children}
    </span>
  );
}
